import { create } from 'zustand';
import { persist, devtools } from 'zustand/middleware';
const initialState = {
    soulId: null,
    sessionToken: null,
    pendingRoomId: null,
    roomPasswords: {},
    createdRooms: [],
    joinedRooms: [],
    createdRoomsLoadedAt: null,
    joinedRoomsLoadedAt: null,
};
export const useSessionStore = create()(devtools(persist((set, get) => ({
    ...initialState,
    setSoulId: (soulId) => set({ soulId }),
    setSessionToken: (sessionToken) => set({ sessionToken }),
    clearSession: () => set(initialState),
    isSessionValid: () => {
        const state = get();
        return !!(state.soulId && state.sessionToken);
    },
    setPendingRoomId: (roomId) => set({ pendingRoomId: roomId }),
    setRoomPassword: (roomId, password) => set((state) => ({
        roomPasswords: { ...state.roomPasswords, [roomId]: password },
    })),
    getRoomPassword: (roomId) => {
        const state = get();
        return state.roomPasswords[roomId];
    },
    clearRoomData: (roomId) => set((state) => {
        const { [roomId]: _, ...remainingPasswords } = state.roomPasswords;
        return {
            roomPasswords: remainingPasswords,
            pendingRoomId: state.pendingRoomId === roomId ? null : state.pendingRoomId,
        };
    }),
    clearAllRoomData: () => set({
        pendingRoomId: null,
        roomPasswords: {},
    }),
    // Room list cache management
    setCreatedRooms: (rooms) => set({
        createdRooms: rooms,
        createdRoomsLoadedAt: Date.now(),
    }),
    setJoinedRooms: (rooms) => set({
        joinedRooms: rooms,
        joinedRoomsLoadedAt: Date.now(),
    }),
    addCreatedRoom: (room) => set((state) => ({
        createdRooms: [room, ...state.createdRooms],
        createdRoomsLoadedAt: Date.now(),
    })),
    removeCreatedRoom: (roomId) => set((state) => ({
        createdRooms: state.createdRooms.filter((r) => r.id !== roomId),
        createdRoomsLoadedAt: Date.now(),
    })),
    updateCreatedRoom: (roomId, updates) => set((state) => ({
        createdRooms: state.createdRooms.map((r) => r.id === roomId ? { ...r, ...updates } : r),
        createdRoomsLoadedAt: Date.now(),
    })),
    removeJoinedRoom: (roomId) => set((state) => ({
        joinedRooms: state.joinedRooms.filter((r) => r.id !== roomId),
        joinedRoomsLoadedAt: Date.now(),
    })),
    invalidateCreatedRoomsCache: () => set({
        createdRooms: [],
        createdRoomsLoadedAt: null,
    }),
    invalidateJoinedRoomsCache: () => set({
        joinedRooms: [],
        joinedRoomsLoadedAt: null,
    }),
    isCreatedRoomsCacheValid: () => {
        const state = get();
        const CACHE_TTL = 5 * 60 * 1000; // 5分
        return (state.createdRoomsLoadedAt !== null &&
            Date.now() - state.createdRoomsLoadedAt < CACHE_TTL);
    },
    isJoinedRoomsCacheValid: () => {
        const state = get();
        const CACHE_TTL = 5 * 60 * 1000; // 5分
        return (state.joinedRoomsLoadedAt !== null &&
            Date.now() - state.joinedRoomsLoadedAt < CACHE_TTL);
    },
}), {
    name: 'darkchat-session',
    partialize: (state) => ({
        soulId: state.soulId,
        sessionToken: state.sessionToken,
        pendingRoomId: state.pendingRoomId,
        roomPasswords: state.roomPasswords,
        // キャッシュはpersistしない（セッション内のみ）
    }),
}), {
    name: 'session-store',
}));
